module.exports = __webpack_public_path__ + "static/media/background.a083a55f.png";